export const protocolViewerStrings = {
  back: 'Protocolos',
  editButton: 'Editar',
  version: (n: number) => `v${n}`,
  updated: 'Actualizado',
  noContent: 'Este protocolo no tiene contenido todavía.',
  loading: 'Cargando protocolo...',
  notFound: 'Protocolo no encontrado.',
} as const
